import { render, staticRenderFns } from "./ModelComparison.vue?vue&type=template&id=b1b0b16e"
import script from "./ModelComparison.vue?vue&type=script&lang=js"
export * from "./ModelComparison.vue?vue&type=script&lang=js"
import style0 from "./ModelComparison.vue?vue&type=style&index=0&id=b1b0b16e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1b0b16e')) {
      api.createRecord('b1b0b16e', component.options)
    } else {
      api.reload('b1b0b16e', component.options)
    }
    module.hot.accept("./ModelComparison.vue?vue&type=template&id=b1b0b16e", function () {
      api.rerender('b1b0b16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/modelcomparison/assets/frontend/components/ModelComparison.vue"
export default component.exports